import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";

const data = {
  loaders: {
    cssLoader: `<div class="loader-wrapper"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>`,
    loginLoader: `<div id="login-loader-wrapper" class="loader-wrapper"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>`,
  },
  props: {
    context: {
      host: "internal",
    },
  },
};

const routes = constructRoutes(
  document.querySelector("#single-spa-layout"),
  data
);
const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  },
});
const layoutEngine = constructLayoutEngine({
  routes,
  applications,
});

applications.forEach(registerApplication);
layoutEngine.activate();

start();
